/**
 * Canonical metadata for the four "tool" entries surfaced on the dashboard
 * topbar (desktop) and in the mobile bottom-nav Tools popover. Single source
 * of truth so the two surfaces never drift.
 *
 * - `to` is set when the tool has a real internal route. `href` is a stub
 *   used until the destination exists.
 * - `flag` gates visibility against a feature flag. Rhyme DB is always
 *   shown (flag: null); the others gate behind their respective flags.
 */

export const TOOLS = [
  { name: 'Rhyme DB', to: '/tools/rhyme-db', color: '#3b82f6', icon: 'search', flag: null },
  { name: 'RWG', href: '#', color: '#ef4444', icon: 'shuffle', flag: 'tools.rwg' },
  { name: 'Games', href: '#', color: '#eab308', icon: 'gamepad', flag: 'dashboard.new-to-wexabet' },
  { name: 'Training', to: '/training', color: '#22c55e', icon: 'check', flag: 'dashboard.training' },
]

export function ToolIcon({ kind, stroke = '#fff', size = 14 }) {
  const common = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke,
    strokeWidth: 2.4,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  }
  if (kind === 'search') return <svg {...common}><circle cx="11" cy="11" r="7" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>
  if (kind === 'shuffle') return <svg {...common}><polyline points="16 3 21 3 21 8" /><line x1="4" y1="20" x2="21" y2="3" /><polyline points="21 16 21 21 16 21" /><line x1="15" y1="15" x2="21" y2="21" /><line x1="4" y1="4" x2="9" y2="9" /></svg>
  if (kind === 'gamepad') return <svg {...common}><line x1="6" y1="11" x2="10" y2="11" /><line x1="8" y1="9" x2="8" y2="13" /><line x1="15" y1="11" x2="15.01" y2="11" /><line x1="18" y1="13" x2="18.01" y2="13" /><rect x="2" y="6" width="20" height="12" rx="4" /></svg>
  if (kind === 'check') return <svg {...common}><circle cx="12" cy="12" r="10" /><polyline points="9 12 12 15 17 9" /></svg>
  return null
}
